import { render, staticRenderFns } from "./Mel.vue?vue&type=template&id=734db284&scoped=true"
import script from "./Mel.vue?vue&type=script&lang=js"
export * from "./Mel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734db284",
  null
  
)

export default component.exports